// IPropertyField.ts => type IPropertyFieldType
export enum IFieldType {
	string = 'string',
	number = 'number',
	date = 'date',
	time = 'time',
	boolean = 'boolean',
	object = 'object',
	enum = 'enum'
}
